export type GroupsState = {
  deleteGroupLoading: boolean,
  error: string | null,
  groups: Group[],
  loading: boolean,
  patchHideGroupsLoading: boolean,
  sendGlobalReminderLoading: boolean,
  patchIsHiddenPmError: string | null,
  patchIsHiddenPmPending: boolean,
  postGroupLoading: boolean,
  postMassLoading: boolean,
  postMemberFromTeamLoading: boolean,
}
export const state: GroupsState = {
  deleteGroupLoading: false,
  error: null,
  groups: [],
  loading: false,
  patchHideGroupsLoading: false,
  sendGlobalReminderLoading: false,
  patchIsHiddenPmError: null,
  patchIsHiddenPmPending: false,
  postGroupLoading: false,
  postMassLoading: false,
  postMemberFromTeamLoading: false,
}
